import React from 'react';
import 'react-toastify/dist/ReactToastify.css'
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { withRouter } from "react-router";
import Menu from '../js/Components/Main/Menu';

import '../i18n';


function App() { 
  const { t, i18n } = useTranslation();

  function handleLanguageChange(e){
    i18n.changeLanguage(e);
  }


  return (
    <div className="wrapper">
    <Router>
        <Switch>
        <Route path="/:slug/:menuId" strict={false}> 
            <Menu handleLanguageChange={handleLanguageChange} />
        </Route>
        <Route path="/:slug" strict={false}> 
            <Menu handleLanguageChange={handleLanguageChange} />
        </Route>        
             
       
        <Route exact path="/" strict={false}>
              <div>{t("Error")}</div>
        </Route>
      </Switch>  
    </Router>
    </div>
    );
  
}

export default withRouter(App);
